import { ACCOUNT_ENDPOINTS } from '@app/configs/api/account';
import { baseApi } from './baseApi';
export const accountApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAccountNumber: builder.query({
            query: () => ({
                url: ACCOUNT_ENDPOINTS.defaultBankAccount,
            }),
            transformResponse: (response) => response.accountNumber,
        }),
    }),
    overrideExisting: false,
});
export const { useGetAccountNumberQuery } = accountApi;
